import { render, staticRenderFns } from "./ViewKnowledgeGroup.vue?vue&type=template&id=5bec9d8f&"
import script from "./ViewKnowledgeGroup.vue?vue&type=script&lang=js&"
export * from "./ViewKnowledgeGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports